import { tooltipTexts } from '@utility/constants/common';

export type SubTabItem = {
  id: string;
  label: string;
  count?: number;
  hint?: string;
};

export const SHIPPED_TABS = {
  MF: 'MF',
  BatchOrder: 'Batch_Order',
  FBA: 'FBA',
} as const;

export type ShippedCounts = {
  MF?: number;
  MCF?: number;
  FBA?: number;
  BATCH?: number;
};

/* No counts yet means unknown, not empty, so the capsules are left off. */
export function getShippedTabItems(counts?: ShippedCounts): SubTabItem[] {
  const counted = (value: number) => (counts ? value : undefined);

  return [
    {
      id: SHIPPED_TABS.MF,
      label: 'MF',
      /* Manual and multichannel share one tab. */
      count: counted((counts?.MF || 0) + (counts?.MCF || 0)),
      hint: tooltipTexts.mf,
    },
    {
      id: SHIPPED_TABS.BatchOrder,
      label: 'Batch Order',
      count: counted(counts?.BATCH || 0),
      hint: tooltipTexts.batchOrders,
    },
    {
      id: SHIPPED_TABS.FBA,
      label: 'FBA',
      count: counted(counts?.FBA || 0),
      hint: tooltipTexts.fba,
    },
  ];
}

export const RETURNS_TABS = {
  All: 'all',
  Refurbish: 'refurbish',
  Completed: 'completed',
} as const;

export function getReturnsTabItems(): SubTabItem[] {
  return [
    { id: RETURNS_TABS.All, label: 'All' },
    { id: RETURNS_TABS.Refurbish, label: 'Refurbish' },
    { id: RETURNS_TABS.Completed, label: 'Completed' },
  ];
}
